import { createRoot } from 'react-dom/client';

// third party
import CustomSnackBar from 'components/Snackbar';
import { SnackbarProvider } from 'notistack';
import { BrowserRouter } from 'react-router-dom';

// project imports
import App from 'App';

import ApiProvider from 'providers/Api';
import AuthProvider from 'providers/Auth';
import LiffProvider from 'providers/Liff';
import LoadingProvider from 'providers/Loading';
import * as serviceWorker from 'serviceWorker';

// defaultTheme

// style + assets
import 'assets/scss/style.scss';
import { ENV_TYPES } from 'configs/constant';
import configs from 'configs/envConfig';
import 'index.css';

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <LiffProvider liffId={configs.LIFF_ID} mock={configs.STAGE === ENV_TYPES.LOCAL ? require('./mock/liff').default : undefined}>
        <SnackbarProvider
            maxSnack={3}
            Components={{
                success: CustomSnackBar,
                error: CustomSnackBar,
                info: CustomSnackBar
            }}
        >
            <ApiProvider>
                <AuthProvider>
                    <LoadingProvider>
                        <BrowserRouter basename={configs.BASE_NAME}>
                            <App />
                        </BrowserRouter>
                    </LoadingProvider>
                </AuthProvider>
            </ApiProvider>
        </SnackbarProvider>
    </LiffProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
